'use strict';

import { interfaceName } from './utils/params';
import { info as BrowserInfo } from './utils/browser_info';
import { getAjax } from './utils/ajax';
import { ResponsiveMenu } from './proj/responsive_menu';
import { LeftMenu } from './proj/left_menu';
import { FixedHeader } from './proj/fixed_header';
import { Partners } from './proj/partners';
import { RelatedProducts } from './proj/related_products';
import { ContactPageInit } from './proj/contact_page';
import { OrderInit } from './proj/order';
import { SaleInit } from './proj/sale';
import { CalculatorInit } from './proj/calculator';
import { FormsTriggers } from './proj/forms';
import { GalleryPopup } from './proj/gallery_popup';
import { GallerySlider } from './proj/gallery_slider';
import { TopLink } from './proj/top_link';
import { Faqs } from './proj/faqs';

import YandexReachGoal from './proj/ya_metrika_goal_reacher';
import * as Targets from './proj/targets';

let Proj = function(){

};

Proj.prototype.interfaceName = interfaceName;
Proj.prototype.BrowserInfo = BrowserInfo;
Proj.prototype.getAjax = getAjax;
Proj.prototype.ResponsiveMenu = ResponsiveMenu;
Proj.prototype.LeftMenu = LeftMenu;
Proj.prototype.FixedHeader = FixedHeader;
Proj.prototype.Partners = Partners;
Proj.prototype.RelatedProducts = RelatedProducts;
Proj.prototype.ContactPageInit = ContactPageInit;
Proj.prototype.OrderInit = OrderInit;
Proj.prototype.SaleInit = SaleInit;
Proj.prototype.CalculatorInit = CalculatorInit;
Proj.prototype.FormsTriggers = FormsTriggers;
Proj.prototype.GalleryPopup = GalleryPopup;
Proj.prototype.GallerySlider = GallerySlider;
Proj.prototype.TopLink = TopLink;
Proj.prototype.YandexReachGoal = YandexReachGoal;
Proj.prototype.Targets = Targets;
Proj.prototype.Faqs = Faqs;


global.Proj = Proj;
export { Proj };

